module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"toggle":{"buttonLabel":"New","switchLabelOld":"Try Infusionsoft: The Keap Experience","switchLabel":"Try Keap Max","description":"Enjoy more {bold1} and a {bold2} Toggle on and off without losing any of your data. {link}","bold1":"intuitive features,","bold2":"cleaner, brighter interface, and more features, too...","learnMore":"Learn more"}}}')
  delete Component.options._Ctor
}
